import mainAnim from '~/assets/anim/main.riv'
import imgCurve from '~/assets/images/curve.svg'
import imgDecoEllipse from '~/assets/images/deco-ellipse.svg'

import { Fit, Layout, useRive } from '@rive-app/react-canvas'
import { useEffect } from 'react'
import { CloseButton } from '~/components/close-button'
import { DevTools } from '~/components/dev-tools'
import { Dialog } from '~/components/dialog'
import { FixedBottomCTA } from '~/components/fixed-bottom-cta'
import { ForestAppBadge } from '~/components/forest-app-badge'
import { GradientBorderBox } from '~/components/gradient-border'
import { LearnMoreButton } from '~/components/learn-more-button'
import { m } from '~/paraglide/messages'
import { native } from '@forest/native-services'
import { FeatureIcon } from './components/icons/feature'
import { OptionList } from './components/option-list'

export function App() {
  useEffect(() => {
    native.general.logEvent({
      event_name: 'page_view',
      event_params: {
        page_name: 'allowlist_paywall',
      },
    })
  }, [])

  const { RiveComponent } = useRive({
    src: mainAnim,
    artboard: 'paywall_kv',
    stateMachines: ['State Machine 1'],
    layout: new Layout({
      fit: Fit.FitHeight,
    }),
    autoplay: true,
  })

  return (
    <>
      <div
        className="relative flex min-h-screen flex-col items-center overflow-hidden"
        style={{
          backgroundImage:
            'radial-gradient(86.13% 26.26% at 50.13% 51.51%, #2FC9C5 0%, #1C7977 82.21%, #176361 100%)',
        }}
      >
        {/* Bottom decorative shape */}
        <div className="absolute bottom-0 left-0 right-0 top-[664px]">
          <img alt="" className="block size-full max-w-none" src={imgCurve} />
        </div>

        {/* Main content */}
        <div className="relative box-border flex w-full max-w-[640px] shrink-0 flex-col items-center gap-3 px-8 pb-[200px] pt-[calc(32px+var(--safe-area-top))]">
          {/* Header section */}
          <div className="flex w-full flex-col items-center gap-3">
            {/* Forest Plus badge */}
            <ForestAppBadge />

            <div className="space-y-4">
              <h1
                className="w-full whitespace-pre-line text-center text-[32px] font-bold leading-[42px] text-white"
                style={{
                  textShadow: 'rgba(187,245,207,0.47) 0px 0px 20.6px',
                }}
              >
                {m.daily_paywall_allow_list_new_title()}
              </h1>
              <h2 className="whitespace-pre-line text-center text-[#C1F1F1]">
                {m.daily_paywall_allow_list_subtitle()}
              </h2>
            </div>
          </div>

          {/* Hero section */}
          <div className="box-border flex w-full shrink-0 flex-col items-center px-0 pb-[60px] pt-0">
            {/* Hero image */}
            <div className="relative -mx-8 mb-[-60px] h-[400px] w-full shrink-0">
              <div className="absolute left-1/2 top-0 h-full w-screen -translate-x-1/2">
                <RiveComponent />
              </div>
            </div>

            {/* Feature section */}
            <div className="relative mb-[-60px] box-border flex w-full shrink-0 flex-col items-center gap-12">
              {/* Decorative ellipse */}
              <div className="absolute bottom-[-17px] right-[-103px] h-[316px] w-[259px]">
                <div className="absolute inset-[-63.29%_-77.22%]">
                  <img
                    alt=""
                    className="block size-full max-w-none"
                    src={imgDecoEllipse}
                  />
                </div>
              </div>

              <GradientBorderBox
                radius={32}
                borderWidth={1.5}
                gradient="linear-gradient(to top right, #fff 0%, #FFFFFF1A 43%, #fff 69%)"
                className="bg-white/75 p-6 backdrop-blur-[50px]"
                style={{
                  willChange: 'backdrop-filter',
                }}
              >
                <div className="flex w-full flex-col gap-6 p-6">
                  {/* Feature header */}
                  <div className="box-border flex w-full shrink-0 flex-col items-center gap-4 px-6 py-0 leading-[0]">
                    {/* Icon */}
                    <FeatureIcon className="w-[62px]" />

                    {/* Feature title */}
                    <div className="flex w-full min-w-full shrink-0 flex-col justify-center text-center text-xl font-[590] leading-[28px] text-[#439797]">
                      <p>{m.daily_paywall_allow_list_title_2()}</p>
                    </div>
                  </div>

                  {/* Options */}
                  <div className="flex w-full shrink-0 flex-col items-center gap-9">
                    <OptionList />

                    <div>
                      <LearnMoreButton />
                    </div>
                  </div>
                </div>
              </GradientBorderBox>

              {/* Footer text */}
              <div
                className="flex w-full min-w-full shrink-0 flex-col justify-center text-center text-xl font-[590] leading-[28px] text-white"
                style={{
                  textShadow: 'rgba(255,255,255,0.47) 0px 0px 20px',
                }}
              >
                <p>{m.daily_paywall_tree_footer()}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CloseButton className="fixed right-4 top-[calc(var(--safe-area-top)+16px)]" />
      <FixedBottomCTA />
      <Dialog />
      {import.meta.env.MODE !== 'production' && <DevTools />}
    </>
  )
}
